import FullPageLayout from "../../../templates/FullPageLayout";
import { Button, Col, Row } from "antd";
import { NeedHelp } from "../../../atoms/CustomIcons";
import ClientIndividual from "./Tabs/ClientIndividual";
import ClientCompany from "./Tabs/ClientCompany";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { removeClientDetailData, getClientDetails } from "../ducks/actions";

export default function EditClient() {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const clientId = pathSegments[pathSegments.length - 2];

  const clientDetailData = useAppSelector(
    (state) => state?.clients?.clientDetailData
  );

  useEffect(() => {
    dispatch(removeClientDetailData());
  }, [dispatch]);

  useEffect(() => {
    if (clientId) {
      dispatch(getClientDetails(clientId));
    }
  }, [dispatch, clientId]);

  return (
    <FullPageLayout loading={loading || clientDetailData?.loader}>
      <Button className="btn-sm fixedTopBtn">
        <NeedHelp /> Need help?
      </Button>

      <div>
        <Row gutter={8} style={{ width: "672px" }}>
          <Col span={24}>
            <div
              className="title"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <div>
                <h2 style={{ marginBottom: "4px" }}>
                  Edit client
                  <span
                    style={{ textTransform: "capitalize", fontSize: "20px" }}
                  >
                    ({clientDetailData?.data?.type})
                  </span>
                </h2>
                <p>Clients are property owning companies or individuals.</p>
              </div>
            </div>
          </Col>

          <Col span={24}>
            <div>
              <Row gutter={20}>
                <Col span={24}>
                  <div
                    style={{
                      position: "absolute",
                      zIndex: 99,
                      width: "calc(100% - 20px)",
                      left: "11px",
                      top: "0",
                      paddingLeft: "20px",
                      paddingTop: "20px",
                    }}
                  >
                    <h4 style={{ marginBottom: "16px" }}> Client details </h4>
                  </div>

                  {clientDetailData?.data?.type === "company" && (
                    <ClientCompany
                      setLoading={setLoading}
                      companyId={companyId}
                      clientId={clientId}
                      clientDetailData={clientDetailData?.data}
                    />
                  )}

                  {clientDetailData?.data?.type === "individual" && (
                    <ClientIndividual
                      setLoading={setLoading}
                      companyId={companyId}
                      clientId={clientId}
                      clientDetailData={clientDetailData?.data}
                    />
                  )}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </FullPageLayout>
  );
}
